import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { useI18n } from "../i18n/I18nContext";

const inputCls =
  "w-full bg-white border border-slate-300 rounded-lg px-4 py-3 text-[15px] text-[#0a2540] placeholder:text-slate-400 outline-none focus:border-[#0a6ed1] focus:ring-2 focus:ring-[#0a6ed1]/20 transition";

// Reusable lead-capture dialog. `config` = { open, title, description, cta, onSubmit }
const LeadDialog = ({ config, onOpenChange }) => {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "" });
  const [busy, setBusy] = useState(false);
  const open = !!config;

  const close = () => {
    setForm({ name: "", email: "" });
    onOpenChange(null);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) return;
    setBusy(true);
    try {
      await config.onSubmit(form);
      close();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && close()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#0a2540]">
            {config?.title}
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            {config?.description}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("fullNameLead")}</label>
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Jane Doe"
              className={inputCls}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-600 text-[#0a2540] mb-2">{t("workEmailLead")}</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="jane@company.com"
              className={inputCls}
              required
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#0a2540] hover:bg-[#16355c] text-white font-600 px-6 py-3 rounded-full transition-colors disabled:opacity-60"
          >
            {busy ? t("submitting") : config?.cta} <ArrowRight className="w-4 h-4" />
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default LeadDialog;
